<template>
  <div class="w-full h-full space-y-4">
    <!-- Tasks overview -->
    <div class="px-5 rounded-[12px] py-4 border border-grayLight space-y-3" style="background: linear-gradient(180deg, #FFFFFF 0%, #F3F4F6 100%)">
      <div class="flex items-center">
        <p class="font-semibold text-bodyText text-[14px]">Tasks</p>
        <router-link :to="{ name: 'Projects' }" class="ml-1">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="#9CA1A3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>
      <div class="flex gap-2 w-full">
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#222222] rounded-full" :style="{ width: taskSummary.tasks.new_percentage + '%' }"></div>
        </div>
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#222222] rounded-full" :style="{ width: taskSummary.tasks.due_percentage + '%' }"></div>
        </div>
      </div>
      <div class="flex gap-4 text-[12px] text-[#667085]">
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#222222] inline-block"></span>
          {{ taskSummary.tasks.new_this_week }} New this week
        </div>
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#222222] inline-block"></span>
          {{ taskSummary.tasks.due_this_week }} Due this week
        </div>
      </div>
    </div>

    <!-- Completed tasks -->
    <div class="px-5 rounded-[12px] py-4 border border-grayLight space-y-3" style="background: linear-gradient(180deg, #FFFFFF 0%, #F3F4F6 100%)">
      <div class="flex items-center">
        <p class="font-semibold text-bodyText text-[14px]">Completed tasks</p>
        <router-link :to="{ name: 'Projects' }" class="ml-1">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="#9CA1A3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>
      <div class="flex gap-2 w-full">
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#22CE91] rounded-full" :style="{ width: taskSummary.completed_tasks.completed_percentage + '%' }"></div>
        </div>
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#1DB2A1] rounded-full" :style="{ width: taskSummary.completed_tasks.in_review_percentage + '%' }"></div>
        </div>
      </div>
      <div class="flex gap-4 text-[12px] text-[#667085]">
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#22CE91] inline-block"></span>
          {{ taskSummary.completed_tasks.completed }} Completed
        </div>
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#1DB2A1] inline-block"></span>
          {{ taskSummary.completed_tasks.in_review }} In review
        </div>
      </div>
    </div>

    <!-- Task reports -->
    <div class="px-5 rounded-[12px] py-4 border border-grayLight space-y-3" style="background: linear-gradient(180deg, #FFFFFF 0%, #F3F4F6 100%)">
      <div class="flex items-center">
        <p class="font-semibold text-bodyText text-[14px]">Task reports</p>
        <router-link :to="{ name: 'Projects' }" class="ml-1">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="#9CA1A3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>
      <div class="flex gap-2 w-full">
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#EDD8FF] rounded-full" :style="{ width: taskSummary.task_reports.completed_percentage + '%' }"></div>
        </div>
        <div class="relative flex-1 h-[6px] bg-[#F3F4F6] rounded-full overflow-hidden">
          <div class="absolute top-0 left-0 h-full bg-[#FFE196] rounded-full" :style="{ width: taskSummary.task_reports.in_review_percentage + '%' }"></div>
        </div>
      </div>
      <div class="flex gap-4 text-[12px] text-[#667085]">
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#EDD8FF] inline-block"></span>
          {{ taskSummary.task_reports.completed }} Completed
        </div>
        <div class="flex items-center gap-1.5">
          <span class="w-2 h-2 rounded-full bg-[#FFE196] inline-block"></span>
          {{ taskSummary.task_reports.in_review }} In review
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'TasksSummaryComponent',
  data() {
    return {
      taskSummary: {
        tasks: { new_this_week: 0, due_this_week: 0, total: 0, new_percentage: 0, due_percentage: 0 },
        completed_tasks: { completed: 0, in_review: 0, total: 0, completed_percentage: 0, in_review_percentage: 0 },
        task_reports: { completed: 0, in_review: 0, total: 0, completed_percentage: 0, in_review_percentage: 0 },
      },
    };
  },
  methods: {
    async fetchTaskSummary() {
      try {
        const response = await apiClient.get('/web/dashboard/manager/task-summary');
        const data = response.data || {};
        this.taskSummary = {
          tasks: data.tasks || { new_this_week: 0, due_this_week: 0, total: 0, new_percentage: 0, due_percentage: 0 },
          completed_tasks: data.completed_tasks || { completed: 0, in_review: 0, total: 0, completed_percentage: 0, in_review_percentage: 0 },
          task_reports: data.task_reports || { completed: 0, in_review: 0, total: 0, completed_percentage: 0, in_review_percentage: 0 },
        };
      } catch (error) {
        console.error('Error fetching task summary:', error);
      }
    },
  },
  created() {
    this.fetchTaskSummary();
  },
};
</script>
